import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/constants";
import { LuxButton, Eyebrow } from "@/components/lux";
import AdminDashboard from "@/pages/admin/AdminDashboard";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminApp() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const login = () => {
    setRedirecting(true);
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#090A0F] flex items-center justify-center">
        <div className="h-8 w-8 rounded-full border-2 border-[#02AACF] border-t-transparent animate-spin" />
      </div>
    );
  }

  if (user && user.is_admin) return <AdminDashboard />;

  return (
    <div className="min-h-screen bg-[#090A0F] grain flex items-center justify-center px-5">
      <div className="pointer-events-none absolute top-1/3 left-1/2 -translate-x-1/2 h-[400px] w-[400px] rounded-full bg-[#02AACF]/15 blur-[120px]" />
      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-[#12141C] p-8 sm:p-10 text-center">
        <img src={LOGO_URL} alt="LUHAI" className="h-9 mx-auto mb-8" />
        <div className="h-14 w-14 rounded-full bg-[#02AACF]/15 flex items-center justify-center mx-auto text-[#02AACF]">
          <ShieldCheck size={26} />
        </div>
        <Eyebrow className="block mt-6">Private Area</Eyebrow>
        <h1 className="font-display font-bold text-white text-2xl mt-2">Admin Dashboard</h1>
        {user && !user.is_admin ? (
          <p className="text-[#f87171] text-sm mt-4" data-testid="admin-denied">
            Signed in as {user.email}, but this account is not authorized for admin access.
          </p>
        ) : (
          <p className="text-[#94A3B8] text-sm mt-3">Sign in with your authorized Google account to manage bookings, packages and media.</p>
        )}
        <LuxButton className="w-full mt-8" onClick={login} disabled={redirecting} data-testid="admin-login-google">
          <LogIn size={16} /> {redirecting ? "Redirecting…" : "Sign in with Google"}
        </LuxButton>
        <button onClick={() => navigate("/")} className="text-xs text-[#64748B] hover:text-white mt-6 font-mono2" data-testid="admin-back-home">← Back to site</button>
      </div>
    </div>
  );
}
